"use client"

import React, { Component } from "react"
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  Grid,
} from "@mui/material"
import API, { URL_PATH } from "../../src/services/API"
import Toast from "./Toast"

class NutriationTab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nutritionData: {
        menu_ingredients: "",
        menu_allergens: "",
        menu_nutrition: "",
        menu_calories: "",
        menu_fat: "",
        menu_carbohydrates: "",
        menu_protein: "",
        menu_sodium: "",
        menu_sugar: "",
        menu_fiber: "",
        menu_cholesterol: "",
        menu_vitamin_a: "",
        menu_vitamin_c: "",
        menu_calcium: "",
        menu_iron: "",
        menu_saturated_fat: ""
      },
      isLoading: false,
      error: null,
      toast: {
        open: false,
        message: "",
        severity: "success",
      }
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  handleChange = (field, value) => {
    this.setState(prevState => ({
      nutritionData: {
        ...prevState.nutritionData,
        [field]: value
      }
    }))
  }

  saveNutritionData = async () => {
    console.log("Saving nutrition data...")
    const { nutritionData } = this.state
    const { hotelId, menuId, onSuccess } = this.props

    if (!hotelId || !menuId) {
      this.showToast("Hotel ID and Menu ID are required", "error")
      return
    }

    this.setState({ isLoading: true })

    try {
      const payload = {
        hotel_id: hotelId,
        hotel_menu_id: menuId,
        ...nutritionData
      }

      const response = await API(this, "post", URL_PATH.updateNutritionInfo(menuId), payload)

      if (response.status === "success") {
        this.showToast("Nutrition data saved successfully", "success")
        if (onSuccess) {
          onSuccess() // Call the success callback if provided
        }
      } else {
        this.showToast(response.message || "Failed to save nutrition data", "error")
      }
    } catch (error) {
      console.error("Error saving nutrition data:", error)
      this.showToast("An error occurred while saving nutrition data", "error")
    } finally {
      this.setState({ isLoading: false })
    }
  }

loadNutritionData = async () => {
  const { hotelId, menuId } = this.props

  if (!hotelId || !menuId) {
    return
  }

  this.setState({ isLoading: true })

  try {
    const response = await API(this, "get", URL_PATH.getMenuNutrition(menuId))

    if (response && typeof response === "object" && response.data) {
      const nutritionData = response.data;
      this.setState({
        nutritionData: {
          menu_ingredients: nutritionData.menu_ingredients || "",
          menu_allergens: nutritionData.menu_allergens || "",
          menu_nutrition: nutritionData.menu_nutrition || "",
          menu_calories: nutritionData.menu_calories || "",
          menu_fat: nutritionData.menu_fat || "",
          menu_carbohydrates: nutritionData.menu_carbohydrates || "",
          menu_protein: nutritionData.menu_protein || "",
          menu_sodium: nutritionData.menu_sodium || "",
          menu_sugar: nutritionData.menu_sugar || "",
          menu_fiber: nutritionData.menu_fiber || "",
          menu_cholesterol: nutritionData.menu_cholesterol || "",
          menu_vitamin_a: nutritionData.menu_vitamin_a || "",
          menu_vitamin_c: nutritionData.menu_vitamin_c || "",
          menu_calcium: nutritionData.menu_calcium || "",
          menu_iron: nutritionData.menu_iron || "",
          menu_saturated_fat: nutritionData.menu_saturated_fat || ""
        }
      })
    }
  } catch (error) {
    console.error("Error loading nutrition data:", error)
    this.showToast("Failed to load nutrition data", "error")
  } finally {
    this.setState({ isLoading: false })
  }
}

  componentDidMount() {
    this.loadNutritionData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.menuId !== this.props.menuId && this.props.menuId) {
      this.loadNutritionData()
    }
  }

  render() {
    const { nutritionData, isLoading, toast } = this.state

    return (
      <>
        <Box sx={{ width: "100%" }}>
          <Paper
            sx={{
              bgcolor: "#02111B",
              backgroundImage: "none",
              overflow: "hidden",
              mb: 4,
            }}
          >
            <Box sx={{ p: 3 }}>
              {/* Ingredients and Allergens */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Ingredients"
                    value={nutritionData.menu_ingredients}
                    onChange={(e) => this.handleChange("menu_ingredients", e.target.value)}
                    placeholder="e.g., Poha, salt, onion, mustard, curry leaves"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
                  <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Iron (% DV)"
                    type="number"
                    value={nutritionData.menu_iron}
                    onChange={(e) => this.handleChange("menu_iron", e.target.value)}
                    placeholder="e.g., 2"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
                {/* <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Allergens"
                     type="number"
                    value={nutritionData.menu_allergens}
                    onChange={(e) => this.handleChange("menu_allergens", e.target.value)}
                    placeholder="e.g., 20"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid> */}
              </Grid>

              {/* Nutrition and Calories */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Nutrition"
                    value={nutritionData.menu_nutrition}
                    onChange={(e) => this.handleChange("menu_nutrition", e.target.value)}
                    placeholder="e.g., High Fiber"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Calories (kcal)"
                    type="number"
                    value={nutritionData.menu_calories}
                    onChange={(e) => this.handleChange("menu_calories", e.target.value)}
                    placeholder="e.g., 350"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/* Fat and Carbohydrates */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Fat (g)"
                    type="number"
                    value={nutritionData.menu_fat}
                    onChange={(e) => this.handleChange("menu_fat", e.target.value)}
                    placeholder="e.g., 5"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Carbohydrates (g)"
                    type="number"
                    value={nutritionData.menu_carbohydrates}
                    onChange={(e) => this.handleChange("menu_carbohydrates", e.target.value)}
                    placeholder="e.g., 60"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/* Protein and Sodium */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Protein (g)"
                    type="number"
                    value={nutritionData.menu_protein}
                    onChange={(e) => this.handleChange("menu_protein", e.target.value)}
                    placeholder="e.g., 6"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Sodium (mg)"
                    type="number"
                    value={nutritionData.menu_sodium}
                    onChange={(e) => this.handleChange("menu_sodium", e.target.value)}
                    placeholder="e.g., 120"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/* Sugar and Fiber */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Sugar (g)"
                    type="number"
                    value={nutritionData.menu_sugar}
                    onChange={(e) => this.handleChange("menu_sugar", e.target.value)}
                    placeholder="e.g., 2"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Fiber (g)"
                    type="number"
                    value={nutritionData.menu_fiber}
                    onChange={(e) => this.handleChange("menu_fiber", e.target.value)}
                    placeholder="e.g., 3"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/* Cholesterol and Saturated Fat */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Cholesterol (mg)"
                    type="number"
                    value={nutritionData.menu_cholesterol}
                    onChange={(e) => this.handleChange("menu_cholesterol", e.target.value)}
                    placeholder="e.g., 0"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Saturated Fat (g)"
                    type="number"
                    value={nutritionData.menu_saturated_fat}
                    onChange={(e) => this.handleChange("menu_saturated_fat", e.target.value)}
                    placeholder="e.g., 1"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/* Vitamins and Minerals */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Vitamin A (% DV)"
                    type="number"
                    value={nutritionData.menu_vitamin_a}
                    onChange={(e) => this.handleChange("menu_vitamin_a", e.target.value)}
                    placeholder="e.g., 10"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Vitamin C (% DV)"
                    type="number"
                    value={nutritionData.menu_vitamin_c}
                    onChange={(e) => this.handleChange("menu_vitamin_c", e.target.value)}
                    placeholder="e.g., 15"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Calcium (% DV)"
                    type="number"
                    value={nutritionData.menu_calcium}
                    onChange={(e) => this.handleChange("menu_calcium", e.target.value)}
                    placeholder="e.g., 40"
                    sx={{
                      bgcolor: "#02111B",
                      input: { color: "#fff" },
                      label: { color: "#fff" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(255, 255, 255, 0.23)",
                      },
                    }}
                  />
                </Grid>
              
              </Grid>

              {/* Save Button */}
              <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={this.saveNutritionData}
                  disabled={isLoading}
                  sx={{
                    px: 4,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    "&:hover": { bgcolor: "#E6B54E" },
                  }}
                >
                  {isLoading ? "SAVING..." : "SAVE NUTRITION DATA"}
                </Button>
              </Box>
            </Box>
          </Paper>
        </Box>

        {/* Toast Component */}
        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleCloseToast}
        />
      </>
    )
  }
}

export default NutriationTab